/**
 * Request Manual Exit (RME) Statuses
 */

export const RME_IN_REVIEW = 'IN_REVIEW';

export const RME_IN_REVIEW_ID = 1;
export const RME_IN_REVIEW_NAME = 'In Review';
